/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['#login-button{position:fixed;right:10px;bottom:20px;border:0px;background-color:transparent}\n'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvc2hhcmVkL2xvZ2luL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5zY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvYnVpbGQvaG93bXVjaC9zcmMvYXBwL3NoYXJlZC9sb2dpbi9sb2dpbi9sb2dpbi5jb21wb25lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/ngfactory/app/shared/login/login/login.component.scss.ngstyle.ts